import {
    MDBContainer,
} from "mdb-react-ui-kit";
import { mockData } from "./data";
import { FullScreeningModal, FullScreeningReportCard, fullScreeningModalTabs } from "stm-frontend-library";
import { useState } from "react";

const FullScreening = () => {

    const data = mockData?.events;

    const profileKeys = {
        "app.ambientScreening": true,
        "tool.duplicateSubmissions.metadataScreening": true,
        "tool.papermillSimilarity": true,
        "tool.doiAnalysis": false,
        "tool.retractionWatch": true,
        "tool.wordFileMetadata": true,
        "tool.watchlist.fakeAffiliationNames": true,
        "tool.watchlist.fakeNamesOrEmailAddresses": true,
        "tool.watchlist.fakeEmailDomains": true,
        "tool.watchlist.disposableEmailDomains": true,
        // "tool.watchlist.suspectArticles": true,
        // "tool.watchlist.manuscriptsOfferedForSale": true,
        "tool.watchlist.metadataSuspects": true,
    }

    const [isArticleModalOpen, setIsArticleModalOpen] = useState(false);
    const [tabId, setTabId] = useState(fullScreeningModalTabs.externalTools);
    const [datalistIndex, setDatalistIndex] = useState(null);


    const modalContent = data[datalistIndex]?.Attrs
        ? {
            ...data[datalistIndex].Attrs,
            SK: data[datalistIndex]?.SK,
        }
        : "";

    const showInfo = (index, tab) => {
        setTabId(tab);
        setDatalistIndex(index);
        setIsArticleModalOpen(true);
    };


    return (
        <MDBContainer className="my-5">
            <FullScreeningModal
                isOpen={isArticleModalOpen}
                setIsOpen={setIsArticleModalOpen}
                tab={tabId}
                data={modalContent}
                onLoadReport={() => { }}
                onDeleteEvent={() => { }}
                eventDeleting={false}
                // make convertComponentNames one source of truth
                profile={profileKeys}
            />
            {data.length > 0 &&
                data.map((item, index) => (
                    <FullScreeningReportCard
                        key={item.SK}
                        item={item}
                        index={index}
                        showInfo={showInfo}
                        profile={profileKeys}
                    />
                ))}
        </MDBContainer>
    );
};

export default FullScreening;
